<template>
    <div class="go-in">
        <banner img="../assets/img/bgtop.jpg" title="走进三云"/>
        <div class="section">
            <div class="section-content">
                <div class="content-summary">
                    <div class="summary-left">
                        <p class="title" style="font-size: 32px">公司简介</p>
                        <div style="text-align: right">
                            <p class="eTitle" style="font-size: 30px;color:#d9a145;"> 一生二，二生三，三生万物!<br/></p>
                            <p class="eTitle" style="font-size: 30px;margin-top: -30px;color: #d9a145">——道德经</p>
                        </div>
                        <p style="font-weight: bold"> 三云科技，以三为始(始终)而造福万物，以云(计算)为基而联结零售!</p><br/>
                        <p class="content">

                            <b style="font-size: 24px">三云科技</b>&nbsp;是广州三云软件科技有限公司简称，是一家专注于为零售业提供专业云服务及移动互联网软件产品的高科技公司。公司以店铺业绩路线图为指导，以提升店铺业绩为目标，致力于为零售企业提供有思想、有灵魂、有价值的信息化解决方案。
                        </p>
                        <p class="eTitle" style="font-size: 30px;text-align: center">企业使命:&nbsp;三云科技，联结零售
                        </p>
                        <p class="content">
                            <b style="font-size: 24px">解析:&nbsp;</b>
                            专注零售行业，通过三云零售平台，运用云计算及移动互联网工具，将所有零售业者联结，分享知识、智慧工作、创造财富!<br/>

                        </p>
                        <p class="content">
                            <b style="font-size: 16px">产品适用客户范围包括: &nbsp;</b>服装、鞋类、箱包、皮具、珠宝、通讯、钟表、化妆品、医药、保健品等各类零售企业!
                        </p>
                    </div>
                    <div class="summary-right">
                        <p style="margin-top: 10px">请用微信扫一扫联系我们</p>
                        <img src="../assets/img/ercode.png" alt/>
                    </div>
                </div>
                <el-divider class="el-divider-active">
                    <!--                    <i v-show="false" class="el-icon-arrow-down el-icon-arrow-down-active"></i>-->
                </el-divider>

            </div>
        </div>
    </div>
</template>

<script>
    import Banner from "../components/Banner";
    import {swiper, swiperSlide} from "vue-awesome-swiper";

    export default {
        components: {
            Banner,
            swiper,
            swiperSlide
        },
        data() {
            return {
                loading: true,
                honorList: [],
                partnerImg: [],
                courseList: [],
                teamItem: [],
                swiperOption: {
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev"
                    }
                },
                dialogTableVisible: false,
                dialogUrl: "",
                dialogTitle: ""
            };
        },
    };
</script>

<style lang="scss" scoped>
    * {
        margin: 0;
        padding: 0;
    }

    .go-in {
        width: 100%;
        height: 100%;
        background-color: #14679f;
        position: relative;
        overflow: hidden;

        .section {
            width: 100%;

            &-content {
                width: 1240px;
                margin: 0 auto;
                background-color: #fff;

                .content-summary {
                    //height: 500px;
                    display: flex;
                    justify-content: space-around;
                    padding: 100px 0;

                    .summary-left {
                        width: 600px;

                        .title {
                            font-size: 25px;
                            color: #e13834;
                        }

                        .eTitle {
                            font-size: 17px;
                            color: #e13834;
                            padding: 20px 0;
                        }

                        .content {
                            color: #14679f;
                            font-size: 14px;
                            text-indent: 25px;
                            line-height: 30px;
                        }
                    }

                    .summary-right {
                        width: 400px;
                        height: 310px;
                        border: 2px solid #1d42b9;
                        //animation: imgboxkey 4s infinite;
                        border-radius: 10px;
                        margin-top: 80px;
                        text-align: center;

                        img {
                            width: 200px;
                            height: 210px;
                            margin-top: 20px;
                            //animation: imgbo 4s infinite;
                        }
                    }
                }

                //发展历程
                .content-course {
                    padding: 50px 0;

                    .course-time {
                        width: 1000px;
                        height: 400px;
                        margin: 20px auto;

                        .swiper-container {
                            height: 100%;
                        }

                        .time-show {
                            width: 700px;
                            height: 100%;
                            margin: 0 auto;
                            display: flex;

                            .time-show-item {
                                width: 350px;
                                height: 100%;
                                overflow: hidden;
                                display: flex;
                                flex-direction: column;

                                .item-top,
                                .item-bottom {
                                    height: 190px;
                                }

                                .item-bottom {
                                    // display: flex;
                                    // align-content: center;
                                    .item-bottom-content {
                                        background-color: #1667a0;
                                        margin: 20px 0;

                                        p {
                                            color: #fff;
                                            text-align: center;
                                            padding: 15px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                //企业文化
                .content-culture {
                    height: 450px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-start;
                    padding-left: 100px;
                    background-color: #c2daeb;

                    h3 {
                        color: #3c6088;
                        font-size: 26px;
                    }

                    p {
                        color: #3c6088;
                        font-size: 26px;
                        padding: 5px 0;
                    }

                    span {
                        font-weight: 400;
                        line-height: 36px;
                        font-size: 18px;
                        padding: 5px 0;
                    }
                }

                //公司荣誉
                .content-honor {
                    padding: 50px 0;

                    .honor-show {
                        width: 1000px;
                        margin: 30px auto;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: flex-start;
                        align-content: flex-start;

                        li {
                            width: 220px;
                            height: 320px;
                            margin-left: 15px;
                            list-style: none;
                            border: 1px solid palegoldenrod;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }

                    p {
                        text-align: center;
                        color: #3c6088;
                    }
                }

                //团队风采
                .content-team {
                    padding: 50px 100px;

                    .swiper-img {
                        height: 400px;
                        background: no-repeat center;
                        background-size: cover;
                    }
                }

                //合作伙伴
                .content-partner {
                    padding: 50px 0;

                    .partner-img {
                        width: 950px;
                        margin: 20px auto;
                        display: flex;
                        justify-content: flex-start;
                        flex-wrap: wrap;

                        li {
                            width: 107px;
                            height: 107px;
                            list-style: none;
                            margin: 10px 25px;

                            img {
                                width: 100%;
                                height: 100%;
                                border: 1px solid rgb(194, 218, 235);
                            }
                        }
                    }
                }
            }
        }
    }

    @keyframes imgboxkey {
        0% {
            border: solid rgb(29, 66, 185) 2px;
        }
        40% {
            border: solid rgb(255, 255, 255) 2px;
        }
        60% {
            border: solid rgb(255, 255, 255) 2px;
        }
        100% {
            border: solid rgb(29, 66, 185) 2px;
        }
    }

    @keyframes imgbo {
        0% {
            transform: scale(1);
            box-shadow: 0px 0px 0px 0px #ababab;
        }
        50% {
            transform: scale(1.1);
            box-shadow: 0px 0px 10px 5px #ababab;
        }
        100% {
            transform: scale(1);
            box-shadow: 0px 0px 0px 0px #ababab;
        }
    }

    .el-divider--horizontal {
        margin: 1px 0;
    }

    .top {
        h3,
        p {
            text-align: center;
            color: #3c6088;
            font-weight: 400;
            padding: 10px 0;
        }

        h3 {
            font-size: 30px;
        }

        p {
            font-size: 20px;
        }

        .border {
            border-bottom: 1px solid #3c6088;
            width: 15%;
            margin: 0 auto;
        }
    }

    // .swiper-button-disabled {
    //   display: none;
    // }
    .order {
        order: -1;
    }

    .order-top {
        order: 1;
    }

    .el-divider {
        background-color: red;
        height: 3px;

        .el-divider__text {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            padding: 0px;
            color: #fff;
            border: 3px solid red;
        }
    }

    .el-divider-active {
        background-color: #3c6088;
    }

    .honor-big-img {
        width: 100%;
        height: 100%;
        z-index: 10;
        text-align: center;
        padding-bottom: 20px;
        padding: 5%;
        //background-color: #14679f;
        .el-dialog__wrapper {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            overflow: auto;
            margin: 0;

            .el-dialog__body {
                overflow: hidden;

                img {
                    width: 100%;
                }
            }
        }
    }
</style>
